module.exports = __webpack_public_path__ + "img/gntech_gallery1.a909d919.jpg";